var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.readdShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "readdRealTime" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n               " +
                _vm._s(_vm.$t("language.cloudBackup.readdCloud")) +
                "\n               "
            ),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.readdShow = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "readd-body" }, [
            _c("div", { staticClass: "readd-info" }, [
              this.source == "aim"
                ? _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("language.cloudBackup.selectedHasAdded"))
                    )
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.cloudBackup.selectedCloud")))
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "realtime-readd-bottom" }, [
              _c(
                "button",
                {
                  staticStyle: { marginRight: "25px" },
                  on: {
                    click: function($event) {
                      return _vm.continueTask()
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("language.cloudBackup.continueAnyway"))
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: {
                    width: "110Px",
                    float: "right",
                    background: "#fff",
                    border: "1px solid #7580c2",
                    color: "#7580c2"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.sureTasK()
                    }
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("language.twoStepverification.cancel"))
                  )
                ]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aacac43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aacac43","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/task_list_popups/readd_cloud_popup.vue
// module id = null
// module chunks = 